const RoleAPI = {
    /**
     * 获取角色列表
     * @param query
     * @returns {*}
     */
    loadRoles(query) {
        return Request.post("/admin/role/search", query || {});
    },
    // 获取租户所有用户的角色
    loadOrganUserRoles(query) {
        return Request.post("/admin/roleUser/findOrganUserWithRoles", query);
    },
    /**
     * @description: 获取当前登录者所具备的角色。
     * @return {*} 返回包含了Role对象的数组
     */
    getCurrentUserRoles() {
        return Request.get("/admin/role/fr_u_r");
    },
    /**
     * 保存角色
     * @param role
     * @returns {*}
     */
    saveRole(role) {
        return Request.post("/admin/role/save", role);
    },

    /**
     * 删除角色
     * @param roleId
     * @returns {*}
     */
    removeRole(roleId) {
        return Request.delete(`/admin/role/delete/${roleId}`);
    },

    /**
     * 删除角色
     * @param roleId
     * @returns {*}
     */
    batchRemoveRole(idArray) {
        return Request.post(`/admin/role/batchDelete`, idArray);
    },

    /**
     * 为一个角色赋权
     */
    assignRights(roleId, menuIdArray) {
        let data = {
            roleId: roleId,
            menus: menuIdArray
        };
        return Request.post('/admin/role/assignRights', data)
    }
};
export default RoleAPI;